import { handleActions } from 'redux-actions';
import Types from './types';
import {
  ClientMaintenanceFields,
  ClientMaintenanceHistoryResponse,
  ClientMaintenanceHistoryRetrieveFields,
  EnvironmentMaintenanceFields,
  EnvironmentMaintenanceHistoryResponse,
  EnvironmentMaintenanceHistoryRetrieveFields,
  MaintenanceState,
} from './interfaces';

const initialState: MaintenanceState = {
  isLoadingEnvironmentMaintenance: false,
  isLoadingClientMaintenance: false,
  environmentMaintenance: {} as EnvironmentMaintenanceFields,
  clientMaintenance: {} as ClientMaintenanceFields,
  environmentMaintenanceHistory: {} as EnvironmentMaintenanceHistoryResponse,
  clientMaintenanceHistory: {} as ClientMaintenanceHistoryResponse,
  environmentMaintenanceHistoryRetrieve: {} as EnvironmentMaintenanceHistoryRetrieveFields,
  clientMaintenanceHistoryRetrieve: {} as ClientMaintenanceHistoryRetrieveFields,
  isLoadingEnvironmentHistoryMaintenance: false,
  isLoadingClientHistoryMaintenance: false,
};

export default handleActions(
  {
    [Types.GET_ENVIRONMENT_MAINTENANCE_REQUEST]: (state: MaintenanceState) => ({
      ...state,
      isLoadingEnvironmentMaintenance: true,
    }),
    [Types.GET_ENVIRONMENT_MAINTENANCE_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      environmentMaintenance: payload,
      isLoadingEnvironmentMaintenance: false,
    }),
    [Types.GET_ENVIRONMENT_MAINTENANCE_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentMaintenance: false,
    }),

    [Types.GET_CLIENT_MAINTENANCE_REQUEST]: (state: MaintenanceState) => ({
      ...state,
      isLoadingClientMaintenance: true,
    }),
    [Types.GET_CLIENT_MAINTENANCE_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      clientMaintenance: payload,
      isLoadingClientMaintenance: false,
    }),
    [Types.GET_CLIENT_MAINTENANCE_REJECTED]: (state: MaintenanceState) => ({
      ...state,
      isLoadingClientMaintenance: false,
    }),

    [Types.SET_ENVIRONMENT_MAINTENANCE_REQUEST]: (state: MaintenanceState) => ({
      ...state,
      isLoadingEnvironmentMaintenance: true,
    }),
    [Types.SET_ENVIRONMENT_MAINTENANCE_FULFILLED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentMaintenance: false,
    }),
    [Types.SET_ENVIRONMENT_MAINTENANCE_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentMaintenance: false,
    }),

    [Types.SET_CLIENT_MAINTENANCE_REQUEST]: (state: MaintenanceState) => ({
      ...state,
      isLoadingClientMaintenance: true,
    }),
    [Types.SET_CLIENT_MAINTENANCE_FULFILLED]: (state: MaintenanceState) => ({
      ...state,
      isLoadingClientMaintenance: false,
    }),
    [Types.SET_CLIENT_MAINTENANCE_REJECTED]: (state: MaintenanceState) => ({
      ...state,
      isLoadingClientMaintenance: false,
    }),

    [Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentHistoryMaintenance: true,
    }),
    [Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      environmentMaintenanceHistory: payload,
      isLoadingEnvironmentHistoryMaintenance: false,
    }),
    [Types.GET_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentHistoryMaintenance: false,
    }),

    [Types.GET_CLIENT_MAINTENANCE_HISTORY_REQUEST]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingClientHistoryMaintenance: true,
    }),
    [Types.GET_CLIENT_MAINTENANCE_HISTORY_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      clientMaintenanceHistory: payload,
      isLoadingClientHistoryMaintenance: false,
    }),
    [Types.GET_CLIENT_MAINTENANCE_HISTORY_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingClientHistoryMaintenance: false,
    }),

    [Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentHistoryMaintenance: true,
    }),
    [Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      environmentMaintenanceHistoryRetrieve: payload,
      isLoadingEnvironmentHistoryMaintenance: false,
    }),
    [Types.RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingEnvironmentHistoryMaintenance: false,
    }),

    [Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REQUEST]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingClientHistoryMaintenance: true,
    }),
    [Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_FULFILLED]: (
      state: MaintenanceState,
      { payload }
    ) => ({
      ...state,
      clientMaintenanceHistoryRetrieve: payload,
      isLoadingClientHistoryMaintenance: false,
    }),
    [Types.RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REJECTED]: (
      state: MaintenanceState
    ) => ({
      ...state,
      isLoadingClientHistoryMaintenance: false,
    }),
  },
  initialState
);
